// extracted by mini-css-extract-plugin
module.exports = {"TicketCount":"TicketCount_TicketCount__1H9IV","TicketCount__Emphasis":"TicketCount_TicketCount__Emphasis__32y5C"};